module.exports = __webpack_public_path__ + "ab8e91886a91f9b6227468b13f212858.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/wall_items/surfboard.png
// module id = 3249
// module chunks = 0